import React, { useEffect, useState, useMemo } from "react";
import HeaderTable from "../DataTable/HeaderTable";
import PaginationComponent from "../DataTable/Pagination";
import SearchTable from "../DataTable/Search";
import { Link } from "react-router-dom";
import "./style.css";
import ReactExport from "react-export-excel";
import Api from "../../services/api";
import provinces_ids from "../../assets/constant";

import { changeIndexToNepali, colorScale } from "../../utils";
import { Button } from "reactstrap";
const province_data = [
  "koshi",
  "madhesh",
  "bagmati",
  "gandaki",
  "lumbini",
  "karnali",
  "Sudurpashchim",
];
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
export default function CustomTable({
  comments,
  title,
  categories,
  download,
  no_link,
  ministryLevel
}) {
  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [refresh, setRrefresh] = useState(false);
  const [yekcolumn, setyekcolumn] = useState([]);
  const [sorting, setSorting] = useState({ field: "", order: "" });
  const [downloadcontent, setDownloadContent] = useState();
  const [yekdata, seYekData] = useState();
  const ITEMS_PER_PAGE = 10;
  const province_id = provinces_ids[window.location.href.split("/").slice(-1)[0].toLowerCase()];
  const fullMarks =ministryLevel? [
    { id: "7", marks: null},
    { id: "6", marks: 50 },
    { id: "5", marks: 50 },
    { id: "4", marks: 50 },
    { id: "3", marks: 51 },
    { id: "2", marks: 75 },
    { id: "1", marks: 116 },
  ]:[
    { id: "7", marks: null},
    { id: "6", marks: 72 },
    { id: "5", marks: 50 },
    { id: "4", marks: 50 },
    { id: "3", marks: 56 },
    { id: "2", marks: 60 },
    { id: "1", marks: 116 },
  ];
  // const yek_fullMarks = [
  //   { id: "7", marks: 100 },
  //   { id: "6", marks: 100 },
  //   { id: "5", marks: 50 },
  //   { id: "4", marks: 100 },
  //   { id: "3", marks: 56 },
  //   { id: "2", marks: 60 },
  //   { id: "1", marks: 116 },
  // ];
  // const downloadminstryreport = async () => {
  //   let data = await Api.downloadMinistryReport(
  //     localStorage.getItem("fiscalYear"),
  //     sessionStorage.getItem("provinceId")
  //   );
  //   seYekData(data);
  //   let a = data.response.data[0].question[0].ministry;
  //   setyekcolumn([
  //     { ministry_name: "क्र.स." },
  //     { ministry_name: "प्रश्नहरू" },
  //     ...a.map((p) => {
  //       return { ministry_name: p.ministry_name };
  //     }),
  //   ]);
  //   let questionArray = [];
  //   for (let i = 0; i < data.response.data.length; i++) {
  //     for (let j = 0; j < data.response.data[i].question.length; j++) {
  //       const questionName = data.response.data[i].question[j].question_name;
  //       const ministryScores = data.response.data[i].question[j].ministry;
  //       const indicator = data.response.data[i].question[j].indicator;

  //       const row = {
  //         "क्र.स.": changeIndexToNepali(indicator),
  //         प्रश्नहरू: questionName,
  //       };
  //       for (let k = 0; k < ministryScores.length; k++) {
  //         row[ministryScores[k].ministry_name] = changeIndexToNepali(
  //           ministryScores[k].score
  //         );
  //       }
  //       questionArray.push(row);
  //     }
  //   }
  //   console.log(questionArray);
  //   setDownloadContent(questionArray);
  // };

  const downloadminstryreport = async () => {
    try {
      let data = await Api.downloadMinistryReport(
        localStorage.getItem("fiscalYear"),
        province_id
      );
      seYekData(data);
  
      if (
        data &&
        data.response &&
        data.response.data &&
        data.response.data.length > 0 &&
        data.response.data[0].question &&
        data.response.data[0].question.length > 0
      ) {
        let a = data.response.data[0].question[0].ministry;
        setyekcolumn([
          { ministry_name: "क्र.स." },
          { ministry_name: "प्रश्नहरू" },
          ...a.map((p) => {
            return { ministry_name: p.ministry_name };
          }),
        ]);
  
        let questionArray = [];
        for (let i = 0; i < data.response.data.length; i++) {
          for (let j = 0; j < data.response.data[i].question.length; j++) {
            const questionName = data.response.data[i].question[j].question_name;
            const ministryScores = data.response.data[i].question[j].ministry;
            const indicator = data.response.data[i].question[j].indicator;
  
            const row = {
              "क्र.स.": changeIndexToNepali(indicator),
              प्रश्नहरू: questionName,
            };
            for (let k = 0; k < ministryScores.length; k++) {
              row[ministryScores[k].ministry_name] = changeIndexToNepali(
                ministryScores[k].score
              );
            }
            questionArray.push(row);
          }
        }
        console.log(questionArray);
        setDownloadContent(questionArray);
      } else {
        // Handle case when data structure is unexpected or empty
      }
    } catch (error) {
      // Handle error if the API call fails
      console.error('Error fetching data:', error);
    }
  };
  
  useEffect(() => {
    downloadminstryreport();
  }, []);
  const displayFullMarks = (id) => {
    console.log("id",id);
    let marks = fullMarks.filter((item) => item.id == id);
    console.log('marks',marks);
    return changeIndexToNepali(marks[0].marks);
  };

  const headers = [
    { name: "क्र.स.", field: "id", sortable: false },
    { name: "मन्त्रालय", field: "name", sortable: false },
    {
      name: `पूर्णांङ्क (${displayFullMarks(
        province_id
      )})`,
      field: "score",
      sortable: false,
    },
  ];
  categories &&
    categories.map((item) =>
      headers.push({
        name: item.name + " (" + changeIndexToNepali(item.total_marks) + ")",
        field: item.name,
        sortable: false,
      })
    );
  console.log(comments);
  const commentsData = useMemo(() => {
    let computedComments = comments;

    if (search) {
      computedComments = computedComments.filter(
        (comment) => comment.name.toLowerCase().includes(search.toLowerCase())
        // ||
        // comment.img.toLowerCase().includes(search.toLowerCase())
      );
    }

    setTotalItems(computedComments && computedComments.length);

    //Sorting comments
    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments = computedComments.sort(
        (a, b) => reversed * a[sorting.field].localeCompare(b[sorting.field])
      );
    }

    //Current Page slice
    return (
      computedComments &&
      computedComments.slice(
        (currentPage - 1) * ITEMS_PER_PAGE,
        (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
      )
    );
  }, [comments, currentPage, search, sorting]);
  // const downloadHandler = async () => {
  //   console.log(yekdata);
  //   if (yekdata) {
  //   }

  //   // setyekcolumn(data.response.data[0]["0"]);
  //   // setDownloadContent(data);
  // };
  const handleministry_id = (m_id, m_name) => {
    window.scroll(0, 0);
    sessionStorage.setItem("m_id", m_id);
    sessionStorage.setItem("m_name", m_name);
  };
  return (
    <div className="card-layout">
      <div className="row">
        <div className="col mb-3 col-12 text-center">
          <div className="row table-heading">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                width: "100%",
                alignItems: "center",
              }}
            >
              <h1 className="sub-heading">{title}</h1>
              {!download && (
                <ExcelFile
                  element={
                    <Button
                      color="primary"
                      className="btn btn-primary"
                      style={{ marginRight: 10, float: "right" }}
                    >
                      डाउनलोड
                    </Button>
                  }
                >
                  {yekcolumn && (
                    <ExcelSheet data={downloadcontent} name="Status">
                      {yekcolumn.map((p) => (
                        <ExcelColumn
                          label={p.ministry_name}
                          value={p.ministry_name}
                        />
                      ))}
                    </ExcelSheet>
                  )}
                </ExcelFile>
              )}
            </div>
          </div>
          {/* {console.log("commentsData", commentsData)} */}
          {!commentsData ? (
            <h4>विवरण उपलब्ध छैन</h4>
          ) : (
            <div className="table-responsive">
              <table className="table">
                <HeaderTable
                  headers={headers}
                  onSorting={(field, order) => setSorting({ field, order })}
                />
                <tbody>
                  {commentsData &&
                    commentsData.map((comment, i) => (
                      <tr>
                        <th scope="row" key={comment.id}>
                          {changeIndexToNepali(++i)}
                        </th>
                        <td>
                          {no_link ? (
                            <p> {comment.name}</p>
                          ) : (
                            <Link
                              onClick={() =>
                                handleministry_id(
                                  comment.ministry_id,
                                  comment.name
                                )
                              }
                              to={`/details/${
                                province_data[
                                  province_id - 1
                                ]
                              }?m_id=${comment.name}`}
                            >
                              {comment.name}
                            </Link>
                          )}
                        </td>
                        <td>{changeIndexToNepali(comment.score)}</td>
                        {comment.categories.map((item) => (
                          <td>{changeIndexToNepali(item)}</td>
                        ))}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
